import * as React from "react";
import { DashboardMenuContainer } from "./DashboardMenu";
import "./dashboardStyle.css";
import { Grid } from "@mui/material";
import NightShelterIcon from "@mui/icons-material/NightShelter";
import ConstructionIcon from "@mui/icons-material/Construction";
import HelpIcon from "@mui/icons-material/Help";
import { useNavigate } from "react-router-dom";
import CategoryButton from "./CategoryButton/CategoryButton";

export default function Dashboard() {
  const navigate = useNavigate();
  return DashboardMenuContainer(
    <Grid container justifyContent={"space-evenly"} alignItems={"center"}>
      <Grid item>
        <CategoryButton
          icon={<NightShelterIcon />}
          text={"Nocľahárne"}
          onClick={() => {
            navigate("/shelters");
          }}
        />
      </Grid>
      <Grid item>
        <CategoryButton
          icon={<HelpIcon />}
          text={"Materiálna pomoc"}
          onClick={() => {
            navigate("/material-helps");
          }}
        />
      </Grid>
      <Grid item>
        <CategoryButton
          icon={<ConstructionIcon />}
          text={"Ponuka práce"}
          onClick={() => {
            navigate("/jobs");
          }}
        />
      </Grid>
    </Grid>
  );
}
